import { render, staticRenderFns } from "./iePopup.vue?vue&type=template&id=68a4cef2&"
import script from "./iePopup.vue?vue&type=script&lang=js&"
export * from "./iePopup.vue?vue&type=script&lang=js&"
import style0 from "./iePopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports